export default __webpack_public_path__ + "static/media/maintenanceSupport.a27838a6.png";